import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = { class: "input-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "ticks", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This action will delay its child actions by the given amount of ticks "),
  /*#__PURE__*/_createVNode("i", null, "(1 tick = 50ms)")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[1] || (_cache[1] = $event => (_ctx.inputTransformer($event, _ctx.action.ticks))),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.ticks = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.action.ticks,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_3
      ])
    ]),
    _hoisted_4
  ]))
}